/**
 * Ajax Forms
 * ======================================
 * - optinal css styles
 * - form validation handled via html5 required attribute
 * - handled with ajax/forms.php
 * - required [hidden] attribute css support
 */

const ELEMENTS = '.ajaxForm'
const SUCCESS_CLASS = 'is-send'
const HIDE_AFTER_SUBMIT = true
const SPAM_PROTECTION = true

class AjaxForm {
	constructor() {
		this.elements = document.querySelectorAll(ELEMENTS)
		this.ajaxUrl = '/app/themes/ipress/ajax/forms.php'

		this.elements.forEach(el => {
			el.addEventListener('submit', this.submitHandler)
		})
	}

	submitHandler = async e => {
		e.preventDefault()

		if (SPAM_PROTECTION && !this.spamProtection(e.target)) {
			location.reload()

			return false
		}

		await this.ajaxHandler(e.target)
	}

	spamProtection = form => {
		const formData = new FormData(form)

		if (formData.getAll('website')[0].length) {
			return false
		}

		return true
	}

	ajaxHandler = async form => {
		const formData = new FormData(form)

		// Získání reCAPTCHA tokenu
		if (window.RECAPTCHA_SITE_KEY && typeof grecaptcha !== 'undefined') {
			try {
				const token = await new Promise((resolve, reject) => {
					grecaptcha.ready(async () => {
						try {
							const t = await grecaptcha.execute(window.RECAPTCHA_SITE_KEY, { action: 'submit' })
							resolve(t)
						} catch (error) {
							reject(error)
						}
					})
				})
				formData.append('recaptcha_token', token)
			} catch (error) {
				console.error('reCAPTCHA error:', error)
				return false
			}
		}

		const parent = form.closest('.ajaxForm__parent')
		const body = parent.querySelector('.ajaxForm__body')
		const message = parent.querySelector('.ajaxForm__message')
		const message_success = parent.querySelector('.ajaxForm-success')
		const message_error = parent.querySelector('.ajaxForm-error')
		const submit = form.querySelector('button[type=submit]')

		submit.classList.add('is-loading')

		const xhr = new XMLHttpRequest()
		xhr.open('POST', this.ajaxUrl, true)
		xhr.send(formData)

		xhr.onreadystatechange = function() {
			if (xhr.readyState === 4) {
				message.removeAttribute('hidden')

				if (HIDE_AFTER_SUBMIT) {
					body.style.display = 'none'
				}

				// ok
				if (xhr.status === 200) {
					message_success.removeAttribute('hidden')

					submit.classList.remove('is-loading')
					parent.classList.add(SUCCESS_CLASS)
				}
				// error
				else {
					message_error.removeAttribute('hidden')
					console.log('ajaxForm error!', xhr)
				}
			}
		}
	}
}

new AjaxForm()
